import api from './base-api-v2';

// eslint-disable-next-line import/prefer-default-export
export const listMemberPrograms = async (payload) => {
  const request = await api.request('get', '/v2/programs', {
    params: payload,
  });
  return request;
};
